const VALID_EMAIL_REGEX = /.+@.+/;
export function validEmail(email) {
  return VALID_EMAIL_REGEX.test(email);
}